import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'

import '@/styles/index.scss' // global css
import '@/styles/ruoyi.scss' // ruoyi css
import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission' // permission control
import Vant from 'vant';
import 'vant/lib/index.css';
import { resetForm } from "@/utils/ruoyi";
import * as echarts from 'echarts'


Vue.use(Vant);
Vue.use(ElementUI, { locale })
Vue.use(VCharts)

Vue.prototype.$echarts = echarts
// 全局方法挂载
Vue.prototype.resetForm = resetForm

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js